import { apiCallService } from '@liebherr/old-sage-ui';
import { Action } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { catchError, filter, finalize, tap } from 'rxjs/operators';

export const finalizeEffect =
    <T extends Action>(finalizeActionCallback?: () => void, errorCallback?: () => void, finalizeApiCallActionType?: string) =>
    (source: Observable<T>) => {
        return source.pipe(
            catchError((error) => {
                if (finalizeApiCallActionType) {
                    apiCallService.notify({ type: finalizeApiCallActionType, payload: error }, true);
                }
                if (errorCallback) {
                    errorCallback();
                }
                console.error(error);
                return EMPTY;
            }),
            filter((a) => a !== undefined),
            tap((a) => {
                if (finalizeApiCallActionType) {
                    apiCallService.notify({ ...a, type: finalizeApiCallActionType });
                }
            }),
            finalize(() => {
                if (finalizeActionCallback) {
                    finalizeActionCallback();
                }
            })
        );
    };
